import { render, staticRenderFns } from "./factorsList.vue?vue&type=template&id=2af30c16"
import script from "./factorsList.vue?vue&type=script&lang=js"
export * from "./factorsList.vue?vue&type=script&lang=js"
import style0 from "./factorsList.vue?vue&type=style&index=0&id=2af30c16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports